<template>
  <v-card :disabled="loading" :loading="loading">
    <v-toolbar color="primary">
      <v-toolbar-title
        ><h1>{{ $t("config_document.config_document") }}</h1></v-toolbar-title
      >
    </v-toolbar>

    <v-card-text class="px-1 px-md-3 px-xl-6">
      <v-tabs v-model="level_tab">
        <v-tab v-for="(level, i) in levels" :key="i">
          <h2>
            {{ objectTranslator(level, "LEVEL_NAME") }}
          </h2>
        </v-tab>
      </v-tabs>

      <v-window v-model="level_tab" touchless>
        <v-window-item v-for="(level, i) in levels" :key="i">
          <v-card>
            <v-card-text class="px-1 px-md-3 px-xl-6">
              <!-- <v-btn
                color="success"
                @click="$refs.addEditDialog.open_add_modal(level.LEVEL_ID)"
                class="mt-3"
                :disabled="true"
              >
                <v-icon>mdi-plus</v-icon>{{ $t("config.addnew") }}
              </v-btn> -->
              <v-table min-height="300px" class="mt-3 text-center">
                <thead class="thead-config">
                  <tr>
                    <!-- <th class="text-center">
                      {{ $t("config.edit") }}
                    </th>
                    <th class="text-center">
                      {{ $t("config.delete") }}
                    </th> -->
                    <th class="text-center">#</th>
                    <th class="text-center">
                      {{ $t("config_document.level_id") }}
                    </th>
                    <th class="text-center">
                      {{ $t("config_document.document_type_name_th") }}
                    </th>
                    <th class="text-center">
                      {{ $t("config_document.document_type_name_en") }}
                    </th>
                    <th class="text-center">
                      {{ $t("config_document.required") }}
                    </th>
                    <th class="text-center">
                      {{ $t("config_document.order") }}
                    </th>
                    <th class="text-center">
                      {{ $t("config_document.example_filepath") }}
                    </th>
                    <th class="text-center">
                      {{ $t("config_document.form_filepath") }}
                    </th>
                    <th class="text-center">
                      {{ $t("config_document.enabled") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(document_item, index) in listFilter(
                      config_documents,
                      level.LEVEL_ID,
                      'LEVEL_ID'
                    )"
                    v-bind:key="document_item.YEAR_ID"
                  >
                    <!-- <td>
                      <v-btn
                        small
                        color="warning"
                        v-on:click="
                          $refs.addEditDialog.open_edit_modal(document_item)
                        "
                      >
                        <v-icon>mdi-pencil</v-icon>{{ $t("config.edit") }}
                      </v-btn>
                    </td>
                    <td>
                      <v-btn
                        small
                        color="error"
                        @click="open_delete_modal(document_item)"
                      >
                        <v-icon>mdi-delete</v-icon>{{ $t("config.delete") }}
                      </v-btn>
                    </td> -->
                    <td>{{ index + 1 }}</td>
                    <td class="text-no-wrap">
                      {{
                        document_item.LEVEL_ID === "1"
                          ? inlineTranslator({
                              th: "ปริญญาตรี",
                              en: "Undergraduate",
                            })
                          : inlineTranslator({
                              th: "บัณฑิตศึกษา",
                              en: "Graduate",
                            })
                      }}
                    </td>
                    <td class="text-left">
                      {{ document_item.DOCUMENT_TYPE_NAME_TH }}
                    </td>
                    <td class="text-left">
                      {{ document_item.DOCUMENT_TYPE_NAME_EN }}
                    </td>
                    <td>
                      <v-icon
                        class="text-success"
                        v-if="document_item.REQUIRED === '1'"
                        >mdi-check</v-icon
                      >
                      <v-icon class="text-error" v-else>mdi-close</v-icon>
                    </td>
                    <td>{{ document_item.ORDER }}</td>
                    <td>
                      <a
                        v-if="document_item.EXAMPLE_FILEPATH"
                        :href="`https://www.reg.kmitl.ac.th/storage/kmitl1/example/${
                          document_item.LEVEL_ID == 1
                            ? 'undergraduate'
                            : 'graduate'
                        }/${document_item.EXAMPLE_FILEPATH}`"
                        target="_blank"
                      >
                        {{ document_item.EXAMPLE_FILEPATH }}
                      </a>
                    </td>
                    <td>
                      <a
                        v-if="document_item.FORM_FILEPATH"
                        :href="`https://www.reg.kmitl.ac.th/storage/kmitl1/form/${
                          document_item.LEVEL_ID == 1
                            ? 'undergraduate'
                            : 'graduate'
                        }/${document_item.FORM_FILEPATH}`"
                        target="_blank"
                      >
                        {{ document_item.FORM_FILEPATH }}
                      </a>
                    </td>
                    <td>
                      <v-icon
                        class="text-success"
                        v-if="document_item.ENABLED === '1'"
                        >mdi-check</v-icon
                      >
                      <v-icon class="text-error" v-else>mdi-close</v-icon>
                    </td>
                  </tr>
                </tbody>
              </v-table>
            </v-card-text>
          </v-card>
        </v-window-item>
      </v-window>
    </v-card-text>

    <!-- <ConfigDocumentAddEditDialog
      ref="addEditDialog"
      :toggle_loading="toggle_loading"
    />

    <ConfigDocumentDeleteDialog
      v-model="showing_delete_modal"
      :title="$t('config_document.config_document')"
      :text="
        to_delete_item
          ? ` ${to_delete_item.ADMIT_SEMESTER}/${to_delete_item.ADMIT_YEAR}`
          : ''
      "
      :deleteFunction="delete_config_document"
    /> -->
  </v-card>
</template>

<script>
import { createHelpers } from "vuex-map-fields";
// import ConfigDocumentAddEditDialog from "./components/ConfigDocumentAddEditDialog";
// import ConfigDocumentDeleteDialog from "./components/ConfigDocumentDeleteDialog";
import {
  objectTranslator,
  inlineTranslator,
  dateFromDBTranslatorFull as d,
  dateTimeFromDBTranslatorFull as dt,
} from "@/helper/translator";
import { getYearsModified } from "@/helper/dateTime";
import { getById } from "@/helper/filter";
import { listFilter } from "@/helper/filter";
// import ConfigProvider from "@/services/config.provider";
// import RefProvider from "@/services/ref.provider";

// const refProvider = new RefProvider();
// const configService = new ConfigProvider();
const { mapFields: mapOfficerConfigFields } = createHelpers({
  getterType: "officerConfig/getField",
  mutationType: "officerConfig/updateField",
});

export default {
  name: "ConfigDocument",

  data: () => ({
    loading: false,
    level_tab: null,
    // config_documents: [],

    showing_delete_modal: false,

    to_delete_id: null,
    to_delete_item: null,

    levels: [
      {
        LEVEL_ID: "1",
        LEVEL_NAME_EN: "Undergraduate",
        LEVEL_NAME_TH: "ปริญญาตรี",
      },
      {
        LEVEL_ID: "2",
        LEVEL_NAME_EN: "Graduate (4+1, Master, Doctor)",
        LEVEL_NAME_TH: "บัณฑิตศึกษา (4+1, โท, เอก)",
      },
    ],
    // all_date_time: [],
  }),

  components: {
    // ConfigDocumentAddEditDialog,
    // ConfigDocumentDeleteDialog,
  },

  computed: {
    ...mapOfficerConfigFields({
      config_documents: "config_documents",
    }),
  },

  methods: {
    d,
    dt,
    objectTranslator,
    inlineTranslator,
    getYearsModified,
    listFilter,
    getById,

    toggle_loading(status) {
      this.loading = status;
    },

    // open_delete_modal: function (item) {
    //   this.to_delete_id = item.YEAR_ID;
    //   this.to_delete_item = item;
    //   this.showing_delete_modal = true;
    // },

    // delete_config_document: async function () {
    //   this.loading = true;
    //   let response = await configService
    //     .deleteYear({
    //       year_id: this.to_delete_id,
    //     })
    //     .catch((error) => {
    //       this.$toast.error(JSON.stringify(error.response.data.message));
    //       this.loading = false;
    //     });
    //   this.showing_delete_modal = false;
    //   this.$store.dispatch("officerConfig/getYears");
    //   if (response && response.status)
    //     this.$toast.success(this.$t("toast.delete_successfully"));
    //   else this.$toast.error(this.$t("toast.cannot_delete"));
    //   this.loading = false;
    // },
  },

  created() {
    this.$store.dispatch("officerConfig/getDocuments");
  },
};
</script>

<style>
th {
  letter-spacing: 1px;
}
</style>
